require('./lbDatePicker.scss');

const lbDatePicker = angular.module('app.lbDatePicker', ['pickadate']);

lbDatePicker.component('lbDatePicker', {
  bindings: {
    settings: '<',
  },
  controllerAs: 'vm',
  controller: ['$document', '$timeout', 'moment', 'ENUMS', 'dateTimeService', controller],
  template: require('./lbDatePicker.html'),
});

function controller($document, $timeout, moment, ENUMS, dateTimeService) {
  let l = document.getElementById('lbDatePickerClose');
  l.focus();

  let vm = this;

  // This format is used to pass to the pickadate plugin, it's limited in what formates it can take it
  const DATE_FORMAT = 'MM/DD/YYYY';
  vm.dateFormat = 'mm/dd/yyyy';

  vm.dateSelected = dateSelected;
  vm.closeDatePicker = closeDatePicker;
  vm.date =
    vm.settings.defaultDate && moment.isMoment(vm.settings.defaultDate)
      ? vm.settings.defaultDate.format(DATE_FORMAT)
      : vm.settings.defaultDate;
  vm.minDateFormatted =
    vm.settings.minDate && moment.isMoment(vm.settings.minDate) ? vm.settings.minDate.format(DATE_FORMAT) : vm.settings.minDate;
  vm.maxDateFormatted =
    vm.settings.maxDate && moment.isMoment(vm.settings.maxDate) ? vm.settings.maxDate.format(DATE_FORMAT) : vm.settings.maxDate;
  vm.rangeFromFormatted =
    vm.settings.rangeFrom && moment.isMoment(vm.settings.rangeFrom) ? vm.settings.rangeFrom.format(DATE_FORMAT) : vm.settings.rangeFrom;
  vm.rangeToFormatted =
    vm.settings.rangeTo && moment.isMoment(vm.settings.rangeTo) ? vm.settings.rangeTo.format(DATE_FORMAT) : vm.settings.rangeTo;

  $document.on('keydown', function (e) {
    keyDown(e);
  });

  function dateSelected(date) {
    vm.settings.input.focus();
    vm.settings.input.selectionEnd = vm.settings.input.selectionStart;

    $timeout(() => {
      $document.unbind('keydown');
      vm.settings.callBack({
        target: vm.settings.parent || vm.settings.input.name,
        date: date,
      });
    }, 0);
  }

  function closeDatePicker() {
    $document.unbind('keydown');
    vm.settings.callBack(null, vm.settings.input);
  }

  function keyDown(e) {
    e.preventDefault();

    switch (e.keyCode) {
      case 39: // Right arrow key
        $timeout(() => {
          vm.date = moment(vm.date, DATE_FORMAT).add(1, 'd').format(DATE_FORMAT);
        }, 0);
        break;

      case 40: // Down arrow key
        $timeout(() => {
          vm.date = moment(vm.date, DATE_FORMAT).add(7, 'd').format(DATE_FORMAT);
        }, 0);
        break;

      case 37: // Left arrow key
        $timeout(() => {
          if (
            vm.settings.minDate == null ||
            (moment.isMoment(vm.settings.minDate) &&
              vm.settings.minDate.isSameOrBefore(moment(vm.date, DATE_FORMAT).subtract(1, 'd'), 'day'))
          )
            vm.date = moment(vm.date, DATE_FORMAT).subtract(1, 'd').format(DATE_FORMAT);
        }, 0);
        break;

      case 38: // Up arrow key
        $timeout(() => {
          if (
            vm.settings.minDate == null ||
            (moment.isMoment(vm.settings.minDate) &&
              vm.settings.minDate.isSameOrBefore(moment(vm.date, DATE_FORMAT).subtract(7, 'd'), 'day'))
          ) {
            vm.date = moment(vm.date, DATE_FORMAT).subtract(7, 'd').format(DATE_FORMAT);
          }
        }, 0);
        break;

      case 13: // Enter key
        $timeout(() => {
          dateSelected(moment(vm.date, DATE_FORMAT));
        }, 0);
        break;

      case 9: // Tab key
        $timeout(() => {
          dateSelected(moment(vm.date, DATE_FORMAT));
        }, 0);
        break;

      default:
        console.warn('keyCode not assigned');
    }
  }
}

export default lbDatePicker;



// WEBPACK FOOTER //
// ./src/components/lbDatePicker/lbDatePicker.js